import React from 'react';
import './TrendSparkline.css';

const TrendSparkline = ({ data, width = 80, height = 30 }) => {
  if (!data || data.length === 0) {
    return <span className="trend-sparkline-empty">—</span>;
  }

  const sortedData = [...data].slice(0, 12).reverse();

  const values = sortedData.map(d => d.monthlySearches);
  const min = Math.min(...values);
  const max = Math.max(...values);
  const range = max - min || 1;

  const padding = 2;
  const chartWidth = width - padding * 2;
  const chartHeight = height - padding * 2;

  const points = sortedData.map((point, index) => {
    const x = padding + (index / (sortedData.length - 1 || 1)) * chartWidth;
    const y = padding + chartHeight - ((point.monthlySearches - min) / range) * chartHeight;
    return `${x},${y}`;
  }).join(' ');

  const firstValue = sortedData[0]?.monthlySearches || 0;
  const lastValue = sortedData[sortedData.length - 1]?.monthlySearches || 0;
  const trendClass = lastValue > firstValue ? 'trend-up' : lastValue < firstValue ? 'trend-down' : 'trend-flat';

  return (
    <div className={`trend-sparkline ${trendClass}`} title={`${sortedData.length} mois de données`}>
      <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`}>
        <polyline
          points={points}
          fill="none"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
};

export default TrendSparkline;
